import React, { useState, useEffect } from "react";

export default function VerizonFooter() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [cookieBannerVisible, setCookieBannerVisible] = useState(true);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return (
    <>
      {isMobile
        ? <MobileFooter />
        : <DesktopFooter />
      }

      {cookieBannerVisible && (
        <div style={shared.cookieBanner}>
          <span style={shared.cookieText}>
            We use technologies to collect and share information about your use of our site.
            By continuing, you agree to the use of these capabilities for a better experience and other purposes.
            Learn more in our{" "}
            <span style={shared.cookieLink}>Privacy Policy.</span>
          </span>
          <button style={shared.closeBtn} onClick={() => setCookieBannerVisible(false)}>
            Close
          </button>
        </div>
      )}
    </>
  );
}

/* ── Mobile footer ── */
const mobileSections = [
  "About Verizon",
  "Most Popular",
  "Top Accessory Brands",
  "Important Consumer Information",
];

function MobileFooter() {
  const [open, setOpen] = useState(null);
  const toggle = (s) => setOpen(open === s ? null : s);

  return (
    <footer style={m.footer}>
      {/* Accordion sections */}
      {mobileSections.map((section) => (
        <div key={section} style={m.accordionItem}>
          <button style={m.accordionBtn} onClick={() => toggle(section)}>
            <span style={m.accordionLabel}>{section}</span>
            <svg
              width="18" height="18" viewBox="0 0 24 24"
              fill="none" stroke="#000" strokeWidth="2"
              style={{ transform: open === section ? "rotate(180deg)" : "rotate(0deg)", transition: "0.2s" }}
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          {open === section && (
            <div style={m.accordionContent}>
              <span style={m.accordionPlaceholder}>—</span>
            </div>
          )}
        </div>
      ))}

      {/* Divider */}
      <div style={m.divider} />

      {/* Follow Verizon */}
      <div style={m.socialSection}>
        <p style={m.socialHeading}>Follow Verizon</p>
        <div style={m.socialIcons}>
          {/* Facebook */}
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#000" style={{ cursor: "pointer" }}>
            <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
          </svg>
          {/* X / Twitter */}
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#000" style={{ cursor: "pointer" }}>
            <path d="M4 4l16 16M20 4 4 20" stroke="#000" strokeWidth="2" fill="none"/>
            <path d="M2 4h7l11 16H13L2 4z" fill="#000"/>
          </svg>
          {/* YouTube */}
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#000" style={{ cursor: "pointer" }}>
            <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.96-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
            <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#fff"/>
          </svg>
          {/* Instagram */}
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2" style={{ cursor: "pointer" }}>
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
            <circle cx="12" cy="12" r="4"/>
            <circle cx="17.5" cy="6.5" r="0.5" fill="#000"/>
          </svg>
          {/* TikTok */}
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#000" style={{ cursor: "pointer" }}>
            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.75a4.85 4.85 0 0 1-1.01-.06z"/>
          </svg>
        </div>
      </div>

      <div style={m.divider} />

      {/* Verizon Support */}
      <div style={m.socialSection}>
        <p style={m.socialHeading}>Verizon Support</p>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="#000" style={{ cursor: "pointer" }}>
          <path d="M4 4l16 16M20 4 4 20" stroke="#000" strokeWidth="2" fill="none"/>
          <path d="M2 4h7l11 16H13L2 4z" fill="#000"/>
        </svg>
      </div>

      <div style={m.divider} />

      {/* Verizon logo + legal */}
      <div style={m.legalSection}>
        <svg viewBox="0 0 120 36" width="110" height="34" style={{ display: "block", marginBottom: 16 }}>
          <text x="0" y="30" fontFamily="Arial Black, sans-serif" fontWeight="1000" fontSize="32" fill="#cd040b">verizon</text>
        </svg>
        {["Privacy Policy", "Your Privacy Choices", "Accessibility", "Open Internet", "Website Terms of Use"].map((item) => (
          <p key={item} style={m.legalLink}>{item}</p>
        ))}
        <p style={m.copyright}>© 2026 Verizon</p>
      </div>

      {/* Chat with us */}
      <div style={m.chatBtn}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
        <span style={{ fontSize: 14, fontWeight: 600 }}>Chat with us</span>
      </div>
    </footer>
  );
}

/* ── Desktop footer ── */
function DesktopFooter() {
  return (
    <>
      <div style={d.footerLinks}>
        <span style={d.link}>Make a one-time payment</span>
        <span style={d.link}>Business Sign in</span>
      </div>
      <footer style={d.footer}>
        <div style={d.footerGrid}>
          {["Shop", "Top Device Brands", "Support", "About Verizon"].map((col) => (
            <div key={col}>
              <div style={d.footerHeading}>{col}</div>
            </div>
          ))}
        </div>
      </footer>
    </>
  );
}

/* ── Shared (cookie banner) ── */
const shared = {
  cookieBanner: {
    position: "fixed", bottom: 0, left: 0, right: 0,
    background: "#fff", borderTop: "1px solid #ccc",
    padding: "14px 24px", display: "flex",
    alignItems: "center", justifyContent: "space-between",
    zIndex: 1000, fontSize: 13,
  },
  cookieText: { flex: 1, marginRight: 16, color: "#333" },
  cookieLink: { color: "#cd040b", textDecoration: "underline", cursor: "pointer" },
  closeBtn: {
    background: "#fff", border: "2px solid #333",
    padding: "6px 20px", cursor: "pointer",
    fontWeight: 700, fontSize: 14, borderRadius: 4,
  },
};

/* ── Mobile styles ── */
const m = {
  footer: { background: "#fff", borderTop: "1px solid #e0e0e0", paddingBottom: 80 },
  accordionItem: { borderBottom: "1px solid #e0e0e0" },
  accordionBtn: {
    width: "100%", display: "flex", justifyContent: "space-between",
    alignItems: "center", padding: "16px", background: "none",
    border: "none", cursor: "pointer",
  },
  accordionLabel: { fontSize: 15, fontWeight: 600, color: "#000" },
  accordionContent: { padding: "0 16px 16px" },
  accordionPlaceholder: { fontSize: 13, color: "#888" },
  divider: { height: 1, background: "#e0e0e0", margin: "4px 0" },
  socialSection: { padding: "16px" },
  socialHeading: { fontSize: 15, fontWeight: 600, color: "#000", marginBottom: 12 },
  socialIcons: { display: "flex", gap: 20, alignItems: "center" },
  legalSection: { padding: "24px 16px" },
  legalLink: { fontSize: 14, color: "#333", marginBottom: 14, cursor: "pointer" },
  copyright: { fontSize: 13, color: "#555", marginTop: 16 },
  chatBtn: {
    position: "fixed", bottom: 60, right: 16,
    background: "#f5f0e8", borderRadius: 24,
    padding: "10px 18px", display: "flex",
    alignItems: "center", gap: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    cursor: "pointer", zIndex: 999,
  },
};

/* ── Desktop styles ── */
const d = {
  footerLinks: {
    display: "flex", padding: "16px 24px",
    maxWidth: 860, fontSize: 13, color: "#000", margin: "0 auto",
  },
  link: { cursor: "pointer", textDecoration: "underline", color: "#000", margin: "-9rem 4rem" },
  footer: { background: "#f6f6f6", borderTop: "1px solid #e0e0e0", padding: "32px 24px" },
  footerGrid: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 24, maxWidth: 1200, margin: "0 auto" },
  footerHeading: { fontWeight: 700, fontSize: 14, marginBottom: 8, color: "#000" },
};